/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectPortalLoginLink
 */
export interface ProjectPortalLoginLink {
    /**
     * Portal URL carrying a short-lived token that signs the caller in as their moderator user
     * @type {string}
     * @memberof ProjectPortalLoginLink
     */
    url: string;
}

export function ProjectPortalLoginLinkFromJSON(json: any): ProjectPortalLoginLink {
    return {
        'url': json['url'],
    };
}

export function ProjectPortalLoginLinkToJSON(value?: ProjectPortalLoginLink): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'url': value.url,
    };
}


